import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

// ¿Tiene la empresa el modelo 347 encendido? (empresas.modulo_347, migración 116)
// Si la columna aún no existe, la consulta falla y se queda apagado.
export function useModulo347(usuario) {
  const [activo, setActivo] = useState(false);
  const empresaId = usuario?.empresa_id;
  const rol = usuario?.rol;

  useEffect(() => {
    if (!empresaId || ["superadmin", "supervisor"].includes(rol)) { setActivo(false); return; }
    let vivo = true;
    supabase.from("empresas").select("modulo_347").eq("id", empresaId).single()
      .then(({ data }) => { if (vivo) setActivo(!!data?.modulo_347); });
    return () => { vivo = false; };
  }, [empresaId, rol]);

  return [activo, setActivo];
}
